// Utility function to toggle steps
const toggleStep = (formElement: HTMLElement, isNextStep: boolean, textSection: HTMLElement) => {
  if (isNextStep) {
    formElement.classList.add('step-two-active');
    textSection.classList.add('text-section--step-two');
  } else {
    formElement.classList.remove('step-two-active');
    textSection.classList.remove('text-section--step-two');

    // Remove ?option= from URL if present.
    const url = new URL(window.location.href);
    url.searchParams.delete("option");
    window.history.pushState({}, "", url.toString());
  }
};

export const initUpsales = () => {
  const textSection = document.querySelector(".text-section") as HTMLElement;
  const formElement = document.querySelector(".form") as HTMLFormElement;
  const prevStepButton = document.getElementById("button--prev-step") as HTMLButtonElement;
  const companyNameWrapper = document.querySelector(".input-with-validation") as HTMLElement | null;
  const companyNameInput = document.getElementById('up-client-name-input') as HTMLInputElement | null;
  const companyNameError = document.getElementById('client-name-validation') as HTMLElement | null;

  // Select all contact buttons
  const contactButtons = document.querySelectorAll(".button-contact") as NodeListOf<HTMLButtonElement>;
  const nextStepButton = document.getElementById("button--next-step") as HTMLButtonElement;

  // Variable to store the button name and value
  let selectedButtonName: string = "";
  let selectedButtonValue: string = "";

  const handleNextStep = () => {

    // If companyNameInput is present, perform validation
    if (companyNameWrapper) {
      if (companyNameInput.value.trim()) {
        // Hide the error message if the company name is filled in
        companyNameError?.classList.remove("validation-error");
        toggleStep(formElement, true, textSection); // Move to the next step
        updateHeading(selectedButtonName); // Update heading with the selected button name
        updateHiddenInputs(selectedButtonValue); // Update hidden input with the selected button value
      } else {
        // Show the error message if the company name is empty
        companyNameError?.classList.add("validation-error");
      }
    } else {
      // If no companyNameInput, just proceed to the next step without validation
      toggleStep(formElement, true, textSection);
      updateHeading(selectedButtonName);
      updateHiddenInputs(selectedButtonValue);
    }
  };

  // Hide the error message when the user starts typing
  companyNameInput.addEventListener('input', () => {
    if (companyNameInput.value.trim()) {
      companyNameError.classList.remove("validation-error");
    }
  });

  const handleContactButtonClick = (button: HTMLButtonElement) => {
    selectedButtonName = button.dataset.buttonName || ""; // Save the button name
    selectedButtonValue = button.dataset.buttonValue || ""; // Save the button value

    // Get the contact-buttons element and cast it as HTMLElement
    const stepTwo = document.querySelector<HTMLElement>(".step--two");

    // Check if selectedButtonValue is "Other"
    if (selectedButtonValue === "Other" || selectedButtonValue === "Consultant" || selectedButtonValue === "Sales" && stepTwo) {
      stepTwo.classList.add("other-selected"); // Add the class if value is "Other"
    } else if (stepTwo) {
      stepTwo.classList.remove("other-selected"); // Remove the class if value is not "Other"
    }

    // Update URL with the selected option
    const url = new URL(window.location.href);
    url.searchParams.set("option", selectedButtonValue);
    window.history.pushState({}, "", url.toString());

    handleNextStep(); // Proceed to the next step
  };

  const handlePrevStep = () => toggleStep(formElement, false, textSection);

  const handleLoadStepFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const option = urlParams.get("option");

    const stepOne = document.querySelector<HTMLElement>(".step--one");
    const stepTwo = document.querySelector<HTMLElement>(".step--two");

    const selectedButton = document.querySelector(`[data-button-value="${option}"]`) as HTMLButtonElement;
    if (selectedButton) {
        const selectedButtonName = selectedButton.dataset.buttonName || "";
        updateHeading(selectedButtonName); // Update the heading based on URL parameter
    }

    if (option) {
        toggleStep(formElement, true, textSection);

        if (option === "Other" || option === "Consultant" || option === "Sales") {
          stepTwo?.classList.add("other-selected");
        }  else {
          stepTwo?.classList.remove("other-selected");
        } 
    } else {
      // If no option is present, return to Step One
      toggleStep(formElement, false, stepTwo as HTMLElement); // Show Step One
  }
  };

  // Call this function on page load
  document.addEventListener("DOMContentLoaded", handleLoadStepFromURL);

  window.addEventListener("popstate", handleLoadStepFromURL);

  // Add event listeners to contact buttons to trigger the next step
  contactButtons.forEach(button => {
    button.addEventListener("click", () => handleContactButtonClick(button));
  });

  // Add event listener to the old next-step button
  nextStepButton.addEventListener("click", handleNextStep);

  prevStepButton.addEventListener("click", handlePrevStep);

  // Function to update the step two heading with the selected button name
  function updateHeading(name: string) {
    const heading = document.querySelector(".step-two--heading") as HTMLElement;
    if (heading) {
      heading.textContent = name; // Set the text content of the heading
    }
  }

  // Function to update the hidden inputs with the selected button value
  function updateHiddenInputs(value: string) {
    const hiddenInputIds = ["client-custom-20", "contact-custom-2"];

    hiddenInputIds.forEach((id) => {
    const hiddenInput = document.getElementById(id) as HTMLInputElement;
    if (hiddenInput) {
      // If there’s already a value, remove the last part (if it was a button value) and append the new button value
      const lastFormData = hiddenInput.value; // Get the current value
      const baseValue = lastFormData.split('-')[0]; // Extract base value (i.e., @lastFormData)

      hiddenInput.value = `${baseValue}-${value}`; // Update hidden input with new value
    }
    });
  }

  // Form validation and status message logic (remains unchanged)
  const fullNameInput = document.getElementById('full-name') as HTMLInputElement;
  const emailInput = document.getElementById('up-email-input') as HTMLInputElement;
  const phoneInput = document.getElementById('phone') as HTMLInputElement;
  const checkboxInput = document.getElementById('checkbox') as HTMLInputElement;


  // Hidden fields for first and last names
  const firstNameInput = document.getElementById("up-firstname-input") as HTMLInputElement;
  const lastNameInput = document.getElementById("up-lastname-input") as HTMLInputElement;

  const inputs = [
    { input: fullNameInput, successId: 'full-name-success', errorId: 'full-name-error', successIconId: 'full-name-success-icon', errorIconId: 'full-name-error-icon', validate: validateFullName },
    { input: emailInput, successId: 'email-success', errorId: 'email-error', successIconId: 'email-success-icon', errorIconId: 'email-error-icon', validate: validateEmail },
    { input: phoneInput, successId: 'phone-success', errorId: 'phone-error', successIconId: 'phone-success-icon', errorIconId: 'phone-error-icon', validate: validatePhone },
    { input: companyNameInput, successId: 'company-name-success', errorId: 'company-name-error', successIconId: 'company-name-success-icon', errorIconId: 'company-name-error-icon', validate: validateCompany }
  ];

  let checkboxTouched = false;

  // Attach validation listeners and check initial values for text inputs
  inputs.forEach(({ input, successId, errorId, successIconId, errorIconId, validate }) => {
    let debounceTimer: number;

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => {
        handleValidation(input, successId, errorId, successIconId, errorIconId, validate);
        
        // If it's the full name input, split into first and last name fields
        if (input === fullNameInput) {
          splitFullName(input.value, firstNameInput, lastNameInput);
        }
      }, 500); // Wait for 500ms after the user stops typing
    });

    if (input.value) {
      handleValidation(input, successId, errorId, successIconId, errorIconId, validate);
      
      // Handle splitting full name on page load if pre-filled
      if (input === fullNameInput) {
        splitFullName(input.value, firstNameInput, lastNameInput);
      }
    }
  });

  checkboxInput.addEventListener('change', () => {
    checkboxTouched = true;
    handleValidation(checkboxInput, 'checkbox-success', 'checkbox-error', '', '', validateCheckbox);
  });

  function handleValidation(
    input: HTMLInputElement,
    successId: string,
    errorId: string,
    successIconId: string,
    errorIconId: string,
    validate: (value: string | boolean) => boolean
  ): boolean {
    const successLabel = document.getElementById(successId) as HTMLElement;
    const errorLabel = document.getElementById(errorId) as HTMLElement;
    const successIcon = document.getElementById(successIconId) as HTMLElement;
    const errorIcon = document.getElementById(errorIconId) as HTMLElement;

    if (successLabel && errorLabel) {
      if (validate(input.type === 'checkbox' ? input.checked : input.value)) {
        successLabel.style.display = 'inline-flex';
        errorLabel.style.display = 'none';

        if (input.type !== 'checkbox') {
          if (successIcon) successIcon.style.display = 'inline-flex';
          if (errorIcon) errorIcon.style.display = 'none';
        }
        return true;
      } else {
        successLabel.style.display = 'none';
        errorLabel.style.display = 'inline-flex';

        if (input.type !== 'checkbox') {
          if (successIcon) successIcon.style.display = 'none';
          if (errorIcon) errorIcon.style.display = 'inline-flex';
        }
        return false;
      }
    } else {
      console.warn(`One or more elements for ${successId}, ${errorId}, ${successIconId}, or ${errorIconId} are not found in the DOM.`);
      return false;
    }
  }

  // Full name validation
  function validateFullName(value: string): boolean {
    const nameParts = value.trim().split(" ");
    return nameParts.length >= 2 && nameParts.every(part => part.length > 1);
  }

  // Email validation
  function validateEmail(value: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value);
  }

  // Phone validation
  function validatePhone(value: string): boolean {
    const phonePattern = /^[\d\s-]+$/;
    const cleanedValue = value.replace(/[\s-]/g, '');
    return cleanedValue.length >= 8 && cleanedValue.length <= 15 && phonePattern.test(value);
  }

  // Checkbox validation
  function validateCheckbox(value: boolean): boolean {
    return value;
  }

  // Company Name validation
  function validateCompany(value: string): boolean {
    return value.trim().length >= 3;
  }


  // Add a click event listener to the submit button
const submitButton = document.querySelector('button[type="submit"]') as HTMLButtonElement;

submitButton.addEventListener("click", () => {
  let isFormValid = true;

  // Trigger validation for all inputs
  inputs.forEach(({ input, successId, errorId, successIconId, errorIconId, validate }) => {
    const isValid = handleValidation(input, successId, errorId, successIconId, errorIconId, validate);
  });

  // Validate the checkbox if it is mandatory
  if (!checkboxTouched) {
    const isCheckboxValid = handleValidation(
      checkboxInput,
      "checkbox-success",
      "checkbox-error",
      "",
      "",
      validateCheckbox
    );
  }
});

  // Function to split full name into first and last name
  function splitFullName(fullName: string, firstNameInput: HTMLInputElement, lastNameInput: HTMLInputElement) {
    const nameParts = fullName.trim().split(" ");
    
    if (nameParts.length === 1) {
      firstNameInput.value = nameParts[0];  // Set first name
      lastNameInput.value = "";             // Clear last name
    } else {
      const lastName = nameParts.pop() || "";  // Extract last word as last name
      const firstName = nameParts.join(" ") || "";  // Remaining words as first name

      firstNameInput.value = firstName;
      lastNameInput.value = lastName;
    }
  }

// Specify the character limit (e.g., 50 characters)
  const characterLimit = 25;

  const addTwoRowsClass = (charLimit: number): void => {
    const heading = document.querySelector<HTMLElement>('.text-section__heading');
    const textSection = document.querySelector<HTMLElement>('.text-section');
  
    if (!heading || !textSection) return;
  
    // Check the length of the text content in the heading
    const textLength = heading.textContent?.trim().length || 0;
  
    // Add or remove the 'two-rows' class based on the character limit
    if (textLength > charLimit) {
      textSection.classList.add('two-rows');
    } else {
      textSection.classList.remove('two-rows');
    }
  };
  
  // Call the function when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', () => addTwoRowsClass(characterLimit));
  
  // Optional: Recheck on window resize if the layout can change
  window.addEventListener('resize', () => addTwoRowsClass(characterLimit));
};